module.exports = __webpack_public_path__ + "static/media/stofferingen-58.7b925e4b.jpg";